import React, { useState } from "react";
import {
  Alert,
  Box,
  Button,
  Chip,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import GlobalDialog from "../../../../components/mui/Dialogue/GlobalDialog";
import { useSelector } from "react-redux";
import {
  getHrLeaveGrantApplications,
  getLeaveGrantRequests,
  hodApproveOrRejectGrant,
  hrApprovalForLeaveGrant,
} from "../../../../redux/features/leaveSlice";
import { Icon } from "@iconify/react/dist/iconify.js";

export default function ApproveLeaveGrant({
  row,
  disabled,
  dispatchData,
  start,
  open,
  setOpen,
  Hr,
}) {
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  // const [open, setOpen] = React.useState(false);

  const { loading } = useSelector((state) => state.leave);

  const [remarks, setRemarks] = useState("");
  const [remarksError, setRemarksError] = useState(false);

  const BASE_URL = process.env.REACT_APP_API_URL;

  const handleApproveorReject = (type) => {
    if (!remarks.trim()) {
      setRemarksError(true);
      return;
    }

    setRemarksError(false);

    const payload = {
      hod_status: type,
      hod_remarks: remarks,
      leaveId: row?.leave_id,
    };

    const Hrpayload = {
      hr_status: type,
      hr_remarks: remarks,
      leaveId: row?.leave_id,
    };

    if (Hr) {
      dispatch(hrApprovalForLeaveGrant(Hrpayload)).then((res) => {
        if (res.payload.status === "success") {
          enqueueSnackbar(res.payload.message, { variant: "success" });
          dispatch(getHrLeaveGrantApplications(dispatchData));
          setOpen(false);
          setRemarks("");
        } else {
          enqueueSnackbar(res.payload.message, { variant: "error" });
          setOpen(false);
          setRemarks("");
        }
      });
    } else {
      dispatch(hodApproveOrRejectGrant(payload)).then((res) => {
        if (res.payload.status === "success") {
          enqueueSnackbar(res.payload.message, { variant: "success" });
          dispatch(getLeaveGrantRequests(dispatchData));
          setOpen(false);
          setRemarks("");
        } else {
          enqueueSnackbar(res.payload.message, { variant: "error" });
          setOpen(false);
          setRemarks("");
        }
      });
    }
  };

  return (
    <div>
      <GlobalDialog
        title={"Action"}
        open={open}
        setOpen={setOpen}
        fullWidth
        maxWidth={"xs"}
        closeButton={true}
        content={
          <>
            <Stack direction={"column"} spacing={2}>
              <TextField
                fullWidth
                label="From Date"
                variant="filled"
                value={row?.from_date}
                inputProps={{ readOnly: true }}
              />
              <TextField
                fullWidth
                label="To Date"
                variant="filled"
                value={row?.to_date}
                inputProps={{ readOnly: true }}
              />
              <TextField
                fullWidth
                label="No of Days"
                variant="filled"
                value={row?.no_of_days}
                inputProps={{ readOnly: true }}
              />
              <TextField
                fullWidth
                label="Reason"
                variant="filled"
                value={row?.reason}
                inputProps={{ readOnly: true }}
              />
              {row?.reason === "medical" && (
                <Button
                  variant="contained"
                  color="info"
                  size="small"
                  startIcon={
                    <Icon
                      icon={"lets-icons:file-fill"}
                      width={18}
                      height={18}
                    />
                  }
                  target="_blank"
                  href={`${BASE_URL}uploads/${row?.scrnShot}`}
                >
                  View Medical Certificate
                </Button>
              )}
              <TextField
                fullWidth
                label="Remarks"
                variant="outlined"
                multiline
                minRows={2}
                value={remarks}
                onChange={(e) => setRemarks(e.target.value)}
                error={remarksError}
                helperText={remarksError ? "Remarks are required." : ""}
              />
            </Stack>
          </>
        }
        actionButton={
          <>
            <Stack paddingBottom={2} spacing={1} direction={"row"}>
              <Button
                variant="outlined"
                color="error"
                size="medium"
                startIcon={
                  <Icon icon="gridicons:cross-circle" width="20" height="20" />
                }
                onClick={() => handleApproveorReject(2)}
              >
                Reject
              </Button>
              <Button
                size="medium"
                variant="outlined"
                color="success"
                startIcon={
                  <Icon
                    icon="teenyicons:tick-circle-solid"
                    width="20"
                    height="20"
                  />
                }
                disabled={loading}
                onClick={() => handleApproveorReject(1)}
              >
                {loading ? "Loading..." : "Approve"}
              </Button>
            </Stack>
          </>
        }
      />
    </div>
  );
}
